import { useEffect } from 'react';

/**
 * Pone el titulo de la PESTANA de una pantalla publica de sesion (BLOG-1-CIERRE, S6).
 *
 * EL DEFECTO, medido con Chrome sobre un build real y con la preferencia de idioma en
 * espanol: `/login`, `/signup` y `/forgot-password` pintaban su cuerpo en espanol
 * ("Bienvenido de vuelta", "Crea tu cuenta", "Olvidaste tu contrasena?") y la PESTANA se
 * quedaba en ingles --- "Log in | StudyBuddy" --- pasara lo que pasara. El motivo: esos
 * tres titulos nacieron en #442 dentro de `scripts/prerender.js`, que los inyecta en el
 * HTML servido, y ningun componente de la app volvia a tocar `document.title`.
 *
 * POR QUE NO CON `<Helmet>`, que es lo que usa `PublicPricingPage`: Helmet necesita su
 * `<HelmetProvider>`, y aunque `App.js` lo monta, las once baterias que montan estas tres
 * pantallas sueltas NO lo hacen. Aqui no hay nada de SEO que declarar --- las tres se
 * sirven con `noindex` a proposito --- : lo unico que hace falta es el titulo, y esto es
 * exactamente eso, sin arrastrar un proveedor a once suites.
 *
 * El titulo del HTML SERVIDO no cambia: lo sigue poniendo el prerender, en ingles, y es lo
 * correcto para un rastreador. Este efecto corre al montar, asi que lo sustituye en cuanto
 * React toma la pagina, y vuelve a correr si el usuario cambia de idioma en vivo (el
 * `titulo` viene de `t(...)`, que cambia con el idioma).
 */
export function usePageTitle(titulo) {
  useEffect(() => {
    if (!titulo || typeof document === 'undefined') return undefined;
    const previo = document.title;
    document.title = titulo;
    // Al desmontar se devuelve el que habia. Sin esto, salir de /login a una pantalla que
    // no pone titulo propio dejaria "Iniciar sesion" en la pestana de otra pagina.
    return () => { document.title = previo; };
  }, [titulo]);
}

export default usePageTitle;
